import { render } from "./LegalFooterComponent.vue?vue&type=template&id=54f3669e&scoped=true"
import script from "./LegalFooterComponent.vue?vue&type=script&lang=js"
export * from "./LegalFooterComponent.vue?vue&type=script&lang=js"

import "./LegalFooterComponent.vue?vue&type=style&index=0&id=54f3669e&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f3669e"]])

export default __exports__